import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoginServiceService } from '../service/login-service.service';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogModalSize, DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { SearchAndSelect } from 'src/modules/base/components/form/models/serachselect.model';
import { Router } from '@angular/router';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { DemographicOtpVerifyComponent } from 'src/modules/kx-shared/components/demographic-otp-verify/demographic-otp-verify.component';

@Component({
  selector: 'app-login-mobile-no',
  templateUrl: './login-mobile-no.component.html',
  styleUrls: ['./login-mobile-no.component.scss'],
  standalone: false
})
export class LoginMobileNoComponent implements OnInit {

  @Output() emitBackEvent = new EventEmitter<any>();
  @Input() logInWith;
  loginForm: FormGroup;
  loginPrimaryForm: FormGroup;
  patientList = [];
  patientLoginId = "";
  submitted = false;
  userDetails: any;
  fromPage: any = 1;
  verify: boolean = false;
  isKarexpert: string = '';
  showFields: boolean = false;
  headerInfo: any = {};
  show_captcha:any=false;
  config = {
    allowNumbersOnly: true,
    length: 6,
    type: 'tel',
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  };
  otp: any;
  ansLabel: any;
  setAnsLabel: any;
  dialogData: any = {};
  timer: number;
  showTimer: boolean = false;
  loginInfo = {};
  checkSecondaccountUrl: boolean = true;
  selectedOption: string = "fname";
  locale = {
    "locale": { "format": "MM/DD/YYYY HH:mm:ss" }
  }
  showGender: boolean = false;
  priObj: any;
  genderData: any;
  primeValue: any;
  patientSearchSelect = {
    question: {
      format: '',
      datasource: []
    },
    defaultsetting: {
      "singleSelection": true,
      "allowSearchFilter": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "advancesearch": false,
      "apliCall": false,
    }
  }
  showFieldsMpin: boolean = false;
  verifymPin: boolean = false;
  setmPin: boolean;
  pin = '';
  confirmPin = '';

  constructor(
    private formBuilder: FormBuilder,
    private baseService: BaseService,
    private loader: LoaderService,
    private alerts: AlertsService,
    private appService: AppService,
    private dialogConfig: DialogConfig,
    public dialog: DialogRef,
    public utilService: UtilService,
    public changeDetectorRef: ChangeDetectorRef,
    public dialogService: DialogService,
    public loginService: LoginServiceService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.headerInfo = this.appService.getAppHeader();
    //  this.headerInfo['pri_log_otp'] = true
    if (window.location.hostname.substring(0, window.location.hostname.indexOf('.')) != 'karexpert' && window.location.hostname != 'localhost') {
      this.loginForm = this.formBuilder.group({
        mob: ['', Validators.required],
        account_id: [window.location.hostname],
        security_question: ['', Validators.required],
        security_ans: ['', Validators.required],
        gender: ['', Validators.required],
        uhid: ['', Validators.required],
        email: ['', Validators.required],
        option: ['', Validators.required],
        captcha: [''],
      });
      this.loginPrimaryForm = this.formBuilder.group({
        mob: ['', Validators.required],
        account_id: [window.location.hostname],
        uhid: ['', Validators.required],
        login_id: ['', Validators.required],
        email: ['', Validators.required],
        option: ['', Validators.required],
        captcha: [''],
      });
    }
    else {
      this.isKarexpert = 'karexpert';
      this.loginForm = this.formBuilder.group({
        mob: ['', Validators.required],
        account_id: ['', Validators.required],
        security_question: ['', Validators.required],
        security_ans: ['', Validators.required],
        gender: ['', Validators.required],
        uhid: ['', Validators.required],
        email: ['', Validators.required],
        option: ['', Validators.required],
        captcha: [''],
      });
      this.loginPrimaryForm = this.formBuilder.group({
        mob: ['', Validators.required],
        account_id: ['', Validators.required],
        login_id: ['', Validators.required],
        uhid: ['', Validators.required],
        email: ['', Validators.required],
        option: ['', Validators.required],
        captcha: [''],
      });
      this.loginForm.controls.option.setValue('fname');
    }
    if (this.dialogConfig) {
      this.dialogData = this.dialogConfig
      if (this.dialogData && this.dialogData.patient && this.dialogData.data) {
        this.headerInfo['pri_log_otp'] = true
        this.verify = true;
        let args = "id:" + this.dialogData.data['currentUser']['user_id']
        this.loader.showSpinner();
        this.baseService.get('GET_BY_ID', args, 'patient', 'patient-registration').subscribe(res => {
          if (res.errCode == 0 && res.resource && res.resource.length > 0) {
            this.loginPrimaryForm.controls.mob.setValue(res.resource[0]['telecom'])
            this.loginPrimaryForm.controls.account_id.setValue(this.isKarexpert == 'karexpert' ? 'ganesha.kxaction.com' : window.location.hostname)
            this.onPrimaryLogin('SEND_MOB_OTP_PIN');
          }
          this.loader.hideSpinner();
        })
      }
    }
    if (this.headerInfo.additional_authentication_required) {
      this.getCaptcha()
    }
    this.loginForm.controls.option.setValue(this.headerInfo.default_login_selection ? this.headerInfo.default_login_selection : 'mob');
    this.loginPrimaryForm.controls.option.setValue('mob');
  }

  get f() { return this.loginForm.controls; } // return form
  get lf() { return this.loginPrimaryForm.controls; } // return form

  onSubmit() {
    this.loader.showSpinner();
    this.submitted = true;
    if (this.loginForm.controls.option.invalid || this.loginForm.controls.account_id.invalid || this.loginForm.controls[this.loginForm.value.option].invalid) {
      this.loader.hideSpinner();
      return;
    }
    if (this.showFields == true) {
      if (this.loginForm.controls.security_question.invalid || this.loginForm.controls.security_ans.invalid) {
        this.alerts.error("Please Fill All Details");
        this.loader.hideSpinner();
        return;
      }
    }
    if (this.showGender == true) {
      if (this.loginForm.controls.gender.invalid) {
        this.alerts.error("Please Fill Gender");
        this.loader.hideSpinner();
        return;
      }
    }
    let args;
    if (this.loginForm.value.gender != undefined && this.loginForm.value.gender != "") {
      args = "option:" + this.loginForm.value.option + "," + this.loginForm.value.option + ':' + this.loginForm.value[this.loginForm.value.option] + ",account_id:" + this.loginForm.value.account_id + ',ques:' + this.loginForm.value.security_question + ',ans:' + this.loginForm.value.security_ans + ',gen:' + this.loginForm.value.gender;
    }
    else if (this.loginForm.value.security_question != undefined && this.loginForm.value.security_question != "" && this.loginForm.value.security_ans != undefined && this.loginForm.value.security_ans != "") {
      args = "option:" + this.loginForm.value.option + "," + this.loginForm.value.option + ':' + this.loginForm.value[this.loginForm.value.option] + ",account_id:" + this.loginForm.value.account_id + ',ques:' + this.loginForm.value.security_question + ',ans:' + this.loginForm.value.security_ans;
    }
    else {
      args = "option:" + this.loginForm.value.option + "," + this.loginForm.value.option + ':' + this.loginForm.value[this.loginForm.value.option] + ",account_id:" + this.loginForm.value.account_id;
    }
    this.baseService.get('VERIFY_MOBILE_NO', args, 'send_otp', 'account-management').subscribe(res => {
      this.loader.hideSpinner();
      this.submitted = false;
      if (res.errCode == -1) {
        this.alerts.error(res.message);
      }
      else if (res.errCode == -1 && res.message == 'Multiple Users Please Select Gender Also') {
        this.showGender = true;
        // let arg = 'resourceId:gender,system:karexpert';
        // this.baseService.get('get_valueset_by_id_flat', arg, 'valueset', 'system-management').subscribe(result => {
        //   if (result.errCode == 0 && result.resource.length > 0) {
        //     //this.genderData = res.resource;
        //   }
        // });
        this.timerFn();
      }
      else if (res.errCode == 0 && res.resource.length == 1) {
        this.alerts.success('Success', res.message);
        this.verify = true;
        // this.loginInfo['account_url'] = res.resource[0].account_url;
        this.loginInfo['login_id'] = res.resource[0].account_id;
        this.timerFn();
      }
      else if (res.errCode == 0 && res.resource < 1) {
        this.alerts.success('Success', res.message);
        this.showFields = true;
        this.checkSecondaccountUrl = false;
      }
    })
  }

  onPrimaryLogin(query_id) {
    this.loader.showSpinner();
    this.submitted = true;
    if (this.headerInfo.additional_authentication_required && this.loginPrimaryForm.controls.captcha.invalid) {
      this.loader.hideSpinner();
      return;
    }
    if (this.loginPrimaryForm.controls[this.loginPrimaryForm.value.option].invalid || this.loginPrimaryForm.controls.account_id.invalid) {
      this.loader.hideSpinner();
      return;
    }
    let args = this.loginPrimaryForm.value.option + ':' + this.loginPrimaryForm.value[this.loginPrimaryForm.value.option] + ",account_id:" + this.loginPrimaryForm.value.account_id;
    this.baseService.get(query_id, args, 'send_otp', 'account-management').subscribe(res => {
      this.loader.hideSpinner();
      this.submitted = false;
      if (res.errCode == -1) {
        this.alerts.error(res.message);
      }
      else if (res.errCode == 0 && res.resource.length > 0) {
        this.alerts.success('Success', res.message);
        this.verify = true;
        this.showFieldsMpin = true;
        this.checkSecondaccountUrl = false;
        this.timerFn();
      }
    })
  }

  verifyPrimaryOtp() {
    this.loader.showSpinner();
    var accountURL = this.loginPrimaryForm.value.account_id.split('.');
    if (accountURL[0].length < 16) {
      accountURL[0] = accountURL[0] + "0000000000000000".substring(0, (16 - accountURL[0].length));
    } else {
      accountURL[0] = accountURL[0].substring(0, 16);
    }
    let args = this.loginPrimaryForm.value.option + ':' + this.loginPrimaryForm.value[this.loginPrimaryForm.value.option] + ",account_id:" + this.loginPrimaryForm.value.account_id + ",otp_no:" + this.appService.encryptText(accountURL[0], this.otp) + ",loggedin:" + this.dialogData?.patient
    if (this.headerInfo.additional_authentication_required) {
      args += ",captcha:" + this.loginPrimaryForm.value.captcha;
    }
    this.baseService.get('VERIFY_OTP_PRI', args, 'send_otp', 'account-management').subscribe(res => {
      this.loader.hideSpinner();
      if (res.errCode == -1) {
        this.alerts.error(res.message);
      }
      else if (res.errCode == 0 && res.resource.length == 1) {
        this.alerts.success('Success', res.message);
        this.patientLoginId = res.resource[0]['login_id'];
        this.loginPrimary('priOtpLogin')
      }
      else if (res.errCode == 0 && res.resource.length > 0) {
        this.alerts.success('Success', res.message);
        this.showFields = true;
        this.patientList = res.resource;
        this.patientSearchSelect['question'] = new SearchAndSelect({
          label: "Select Primary Patient",
          datasource: {
            "application": "account-management",
            "resource": "send_otp",
            "query_id": "VERIFY_OTP_PRI",
            "args": args
          },
          defaultsetting: this.patientSearchSelect.defaultsetting,
          order: 1,
          getterKey: 'login_id',
          getterValue: 'name',
          format: "fn=function(item){ return (item.name) +' | '+ (item.login_id)}",
          options: [],
        });
      }
    })
  }

  onItemSelect(loginId: any) {
    console.log('Selected:', loginId);
    this.patientLoginId = loginId.id
    this.priObj = this.patientList.find(x => x['login_id'] == loginId.id)
  }
  setPrimary(loginId) {
    this.priObj = this.patientList.find(x => x.login_id == loginId)
  }


  loginPrimary(type) {
    this.loader.showSpinner();
    if (this.dialogData?.patient) {
      this.baseService.action(this.priObj, "SET_USER_PRIMARY", 'account-management', 'account_user').subscribe((res) => {
        if (res.errCode == 0) {
          this.alerts.success("Updated Successfully");
          this.dialog.close();
        }
        else if (res.errCode == -1) {
          this.alerts.error(res.message);
        }
        this.loader.hideSpinner()
      })
    }
    if (!this.dialogData?.patient) {
      this.loader.showSpinner();
      this.loginInfo['login_id'] = this.patientLoginId;
      this.loginInfo['password'] = this.pin ? this.pin : this.otp;
      this.loginInfo['account_url'] = this.loginPrimaryForm.value.account_id;
      let obj = {
        [type]: true,
        "request": this.loginPrimaryForm.value.option
      }
      this.loginInfo['extra_data'] = obj;
      if (this.baseService.checkKioskApp()) {
      this.loginInfo['is_kiosk'] = true; // check if kiosk is available and assign KIosk patient role to the user
      }
      var menuParser: any = false;
      try {
        if (this.appService._appData.DECORATOR_DEF['menuParseDecorator'] != undefined) {
          menuParser = new this.appService._appData.DECORATOR_DEF['menuParseDecorator']();
        }
      } catch (e) {
        console.warn(e)
      }
      var loginInfo = this.loginService.encrypt(JSON.parse(JSON.stringify(this.loginInfo)));
      this.baseService.add(loginInfo, 'login').subscribe(
        (data: any) => {
          this.submitted = false;
          if (data.errCode == -1) {
            this.alerts.error(data.message);
            this.loader.hideSpinner();
          }
          else {
            if (data.resource != undefined && data.resource.length) {
              let newData = this.loginService.decryptLoginInfo(data);
              this.loginService.buildApplication(newData, menuParser);
            } else {
              this.alerts.error(data.message);
              this.loader.hideSpinner();
            }
          }
        });
    }
  }

  verifyOtp() {
    this.loader.showSpinner();
    this.loginInfo['password'] = this.otp;
    this.loginInfo['account_url'] = this.loginForm.value.account_id;
    let obj = { "otpLogin": true }
    this.loginInfo['extra_data'] = obj;
    if (this.utilService.isMobile()) {
      this.loginInfo['user_agent'] = 'mobile';
    } else {
      this.loginInfo['user_agent'] = 'web'
    }
    if (this.baseService.checkKioskApp()) {
      this.loginInfo['is_kiosk'] = true; // check if kiosk is available and assign KIosk patient role to the user
    }
    var menuParser: any = false;
    try {
      if (this.appService._appData.DECORATOR_DEF['menuParseDecorator'] != undefined) {
        menuParser = new this.appService._appData.DECORATOR_DEF['menuParseDecorator']();
      }
    } catch (e) {
      console.warn(e)
    }
    var loginInfo = this.loginService.encrypt(JSON.parse(JSON.stringify(this.loginInfo)));
    this.baseService.add(loginInfo, 'login').subscribe(
      (data: any) => {
        this.submitted = false;
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          this.loader.hideSpinner();
        }
        else {
          if (data.resource != undefined && data.resource.length) {
            let newData = this.loginService.decryptLoginInfo(data);
            this.loginService.buildApplication(newData, menuParser);
          } else {
            this.alerts.error(data.message);
            this.loader.hideSpinner();
          }
        }
      });
  }

  onOtpChange(otp) {
    this.otp = otp;
  }
  timerFn() {
    this.timer = 60;
    this.showTimer = true;
    let timerInterval = setInterval(() => {
      this.timer -= 1;
      if (this.timer <= 0) {
        clearInterval(timerInterval);
        this.showTimer = false;
      }
    }, 1000)
  }

  backToLogin() {
    if (!this.showFields && !this.verify && this.checkSecondaccountUrl) {
      this.router.navigateByUrl('account-management/login');
      return;
    }
    // if (!this.verify) {
    //   let val = {
    //     "back": true
    //   }
    //   this.emitBackEvent.emit(val)
    //   return;
    // }
    this.verify = false;
    this.showFields = false;
    this.showGender = false;
    this.checkSecondaccountUrl = true;
    //this.loginForm.reset();
    this.loginForm.controls.option.setValue(this.headerInfo.default_login_selection ? this.headerInfo.default_login_selection : 'mob');
    this.submitted = false;
    if (window.location.hostname.substring(0, window.location.hostname.indexOf('.')) != 'karexpert' && window.location.hostname != 'localhost') { } else {
      this.isKarexpert = 'karexpert';
    }

  }

  setPinOtp() {
    this.loader.showSpinner();
    var accountURL = this.loginPrimaryForm.value.account_id.split('.');
    if (accountURL[0].length < 16) {
      accountURL[0] = accountURL[0] + "0000000000000000".substring(0, (16 - accountURL[0].length));
    } else {
      accountURL[0] = accountURL[0].substring(0, 16);
    }
    let args = this.loginPrimaryForm.value.option + ':' + this.loginPrimaryForm.value[this.loginPrimaryForm.value.option] + ",account_id:" + this.loginPrimaryForm.value.account_id + ",otp_no:" + this.appService.encryptText(accountURL[0], this.otp)
    this.baseService.get('VERIFY_OTP_PRI_PIN', args, 'send_otp', 'account-management').subscribe(res => {
      this.loader.hideSpinner();
      if (res.errCode == -1) {
        this.alerts.error(res.message);
      }
      else if (res.errCode == 0 && res.resource.length == 1) {
        this.setmPin = true;
        this.showFieldsMpin = false;
        this.alerts.success('Success', res.message);
        this.patientLoginId = res.resource[0]['login_id'];
      }
      else if (res.errCode == 0 && res.resource.length > 0) {
        this.setmPin = true;
        this.showFieldsMpin = false;
        this.alerts.success('Success', res.message);
        this.patientList = res.resource;
        this.patientSearchSelect['question'] = new SearchAndSelect({
          label: "Select Primary Patient",
          datasource: {
            "application": "account-management",
            "resource": "send_otp",
            "query_id": "VERIFY_OTP_PRI_PIN",
            "args": args
          },
          defaultsetting: this.patientSearchSelect.defaultsetting,
          order: 1,
          getterKey: 'login_id',
          getterValue: 'name',
          format: "fn=function(item){ return (item.name) +' | '+ (item.login_id)}",
          options: [],
        });
      }
    })
  }

  onPinLogin() {
    this.loader.showSpinner();
    this.submitted = true;
    if (this.loginPrimaryForm.controls[this.loginPrimaryForm.value.option].invalid || this.loginPrimaryForm.controls.account_id.invalid) {
      this.loader.hideSpinner();
      return;
    }
    if (!this.otp) {
      this.loader.hideSpinner();
      this.alerts.error("Please fill PIN");
      return;
    }
    let args = this.loginPrimaryForm.value.option + ':' + this.loginPrimaryForm.value[this.loginPrimaryForm.value.option] + ",account_id:" + this.loginPrimaryForm.value.account_id + ",pin:" + this.otp
    if (this.headerInfo.additional_authentication_required) {
      args += ",captcha:" + this.loginPrimaryForm.value.captcha;
    }
    this.baseService.get('VERIFY_PIN_PRI', args, 'send_otp', 'account-management').subscribe(res => {
      this.loader.hideSpinner();
      this.submitted = false;
      if (res.errCode == -1) {
        this.alerts.error(res.message);
      }
      else if (res.errCode == 0 && res.resource.length == 1) {
        this.alerts.success('Success', res.message);
        this.patientLoginId = res.resource[0]['login_id'];
        this.loginPrimary('pinLogin')
      }
      else if (res.errCode == 0 && res.resource.length > 0) {
        this.alerts.success('Success', res.message);
        this.verifymPin = true;
        this.patientList = res.resource;
        this.patientSearchSelect['question'] = new SearchAndSelect({
          label: "Select Primary Patient",
          datasource: {
            "application": "account-management",
            "resource": "send_otp",
            "query_id": "VERIFY_PIN_PRI",
            "args": args
          },
          defaultsetting: this.patientSearchSelect.defaultsetting,
          order: 1,
          getterKey: 'login_id',
          getterValue: 'name',
          format: "fn=function(item){ return (item.name) +' | '+ (item.login_id)}",
          options: [],
        });
      }
    })
  }

  pinOtpChange(otp) {
    this.pin = otp;
  }
  confirmPinOtpChange(otp) {
    this.confirmPin = otp;
  }

  saveMpin() {
    if (!this.pin) {
      this.alerts.error("Please enter 6 digit Pin");
      return;
    }
    if (!this.confirmPin) {
      this.alerts.error("Please enter 6 digit Confirm Pin");
      return;
    }
    var accountURL = this.loginPrimaryForm.value.account_id.split('.');
    if (accountURL[0].length < 16) {
      accountURL[0] = accountURL[0] + "0000000000000000".substring(0, (16 - accountURL[0].length));
    } else {
      accountURL[0] = accountURL[0].substring(0, 16);
    }
    let args = 'login_id:' + this.appService.encryptText(accountURL[0], this.patientLoginId) + ",account_id:" + this.loginPrimaryForm.value.account_id + ',context:forget_pin,otp_no:' + this.appService.encryptText(accountURL[0], this.otp) + ',pin:' + this.pin + ',cpin:' + this.confirmPin + ',option:' + this.loginPrimaryForm.value.option;
    this.baseService.get('VERIFY_FORGOT_PIN', args, 'otp', 'account-management').subscribe(res => {
      this.loader.hideSpinner()
      if (res.errCode == 0) {
        this.alerts.success(res.message);
        this.loginPrimary('pinLogin')
      }
      else {
        this.alerts.error(res.message);
      }
    })
  }

  onChanged() {
    this.loginForm.controls.mob.setValue("");
    this.loginForm.controls.uhid.setValue("");
    this.loginForm.controls.email.setValue("");
  }
  onChange() {
    this.loginForm.controls.security_ans.setValue("");
    this.showGender = false;
  }

  getCaptcha() {
    this.loginService.getCaptchaResourceDef((question) => {
      if (question) {
        (this.loginPrimaryForm.get('captcha') as any).question = question;
        this.show_captcha = true;
      }
    });
  }

}
